
import {Component, PropSync, Vue} from 'vue-property-decorator';
import {RouteName, SiteId} from "@/enums";
import {RouteListItem, ThemeData} from "@/types";
import store from "@/store";
import {isVariationDiet} from "@/utils/common";
import { t } from '@/utils';


@Component({})
	export default class TopBar extends Vue {
		@PropSync('showTitle', { default: true }) _showTitle!: boolean;
		@PropSync('breadcrumbColor', { default: 'dark-grey' }) _breadCrumbColor!: string;
		@PropSync('showPeriod', { default: true }) _showPeriod!: boolean;
		@PropSync('breadCrumbClickable', { default: true }) _breadCrumbClickable!: boolean;

		private startDate!: Date;
		private endDate!: Date;

		private dateOptions: Intl.DateTimeFormatOptions = {
			weekday: 'short',
			day: '2-digit',
			month: 'long'
		};

		beforeMount() {
			this.startDate = new Date(this.$store.state.registrationPeriod.startDate);
			this.endDate = new Date(this.$store.state.registrationPeriod.endDate);
		}

		private get week(): string {
			return `Uge ${this.$store.state.registrationPeriod.weekNumber}`;
		}

		private get currentTheme(): ThemeData {
			return this.$store.state.currentTheme;
		}

		private changeRoute(routeName: RouteName): void {
			if (!this._breadCrumbClickable) {
				return;
			}

			this.$router.push({
				name: routeName
			});
		}

		private clickHome() {
			this.changeRoute(RouteName.HOME);
		}

		private get currentRouteName(): string | undefined {
			return this.$route.name;
		}

		private get pageOrder(): RouteName[] {
			if (isVariationDiet()) {
				return [RouteName.USER_SURVEY, RouteName.PRE_QUESTION_SURVEY, RouteName.OVERVIEW, RouteName.CHAPTER, RouteName.RESULT];
			}
			return  [RouteName.PRE_QUESTION_SURVEY, RouteName.OVERVIEW, RouteName.CHAPTER, RouteName.OUTRO, RouteName.RESULT];
		}

		private routeLabel(routeName: RouteName): string {
			let routeLabel = '';
			switch (routeName) {
				case RouteName.USER_SURVEY:
					routeLabel = t('userData', 'breadcrumb');
					break;
				/* case RouteName.GATE_SURVEY:
					routeLabel = t('gates', 'breadcrumb');
					break;*/
				case RouteName.PRE_QUESTION_SURVEY:
					routeLabel = t('preQuestions', 'breadcrumb');
					break;
				case RouteName.OVERVIEW:
					routeLabel = t('overview', 'breadcrumb');
					break;
				case RouteName.CHAPTER:
					let currentLabel = this.currentTheme?.label || '';
					routeLabel = currentLabel;
					break;
				case RouteName.OUTRO:
					routeLabel = t('outro', 'breadcrumb');
					break;
				case RouteName.RESULT:
					routeLabel =  t('intake', 'breadcrumb');
					break;
				default:
					console.error(`No RouteName matches the value ${routeName}`);
					routeLabel = ''
			}

			return routeLabel;
		}

		private get breadcrumbList(): RouteListItem[] {
			const breadCrumbList: RouteListItem[]  = [];

			const addBreadcrumbItem = (routeName: RouteName) => {
				breadCrumbList.push({
					label: this.routeLabel(routeName),
					routeName,
				});
			};

			if (this.currentRouteName === RouteName.RESULT) {
				addBreadcrumbItem(RouteName.RESULT);
				return breadCrumbList;
			}

			for (const routeName of this.pageOrder) {

				if (!this.currentTheme?.label && routeName === RouteName.CHAPTER) {
					continue;
				}

				addBreadcrumbItem(routeName);

				if (this.currentRouteName === routeName) {
					break;
				}
			}

			return breadCrumbList;
		}

		private get period(): string {
			return `${this.startDate.toLocaleDateString('da', this.dateOptions)} - ${this.endDate.toLocaleDateString('da', this.dateOptions)}`;
		}

		private get clickableClass(): string {
			if (!this._breadCrumbClickable) {
				return '';
			}

			return 'clickable';
		}

		private get clickableSideLabelClass(): string[] {
			let classList: string[] = [];

			classList.push('top-bar-side-label-color-' + this._breadCrumbColor);
			classList.push(this.clickableClass);

			return classList;
		}
	}
